import { render } from "./VisitorAdultAssignForm.vue?vue&type=template&id=34b74cd7"
import script from "./VisitorAdultAssignForm.vue?vue&type=script&lang=js"
export * from "./VisitorAdultAssignForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__